import $ from 'jquery';
import domReady from '@wordpress/dom-ready';

const $navWithDropdown = $('.nav--with-dropdown');
const dropdownContainerSelector = '.dropdown';
const dropdownToggleClass = 'dropdown__toggle';
const activeClass = 'opened';
const openedSubnav = {};
let uniqueNameCount = 0;

function createUniqueSubnavName() {
  uniqueNameCount++;
  return 'subnav_' + uniqueNameCount;
}

function tryClosingSubnavOnKeyUp(event) {
  if ('Escape' !== event.key) {
    return;
  }
  const openedSubnavKeys = Object.keys(openedSubnav);
  if (!openedSubnavKeys.length) {
    return;
  }
  closeSubnav(openedSubnavKeys[openedSubnavKeys.length - 1]);
}

function tryClosingSubnav(event) {
  for (const subnavName in openedSubnav) {
    if ('undefined' === typeof subnavName) {
      continue;
    }
    const $target = openedSubnav[subnavName].find(event.target);
    if (!$target.length) {
      closeSubnav(subnavName);
      continue;
    }
  }
}

function getOpenedSubnavByName(subnavName) {
  if (!openedSubnav[subnavName]) {
    console.warn(
      subnavName + " n'existe pas encore. (getOpenedSubnavByName())"
    );
    return $();
  }
  return openedSubnav[subnavName];
}

function getSubnavName($subnav) {
  let subnavName = $subnav.data('subnav');
  if (!subnavName) {
    subnavName = createUniqueSubnavName();
    $subnav.data('subnav', subnavName);
  }
  return subnavName;
}

function setOpenedSubnav($subnav) {
  const subnavName = getSubnavName($subnav);
  openedSubnav[subnavName] = $subnav;
}

function openSubnav(subnavName) {
  const $subnav = getOpenedSubnavByName(subnavName);
  $subnav.addClass(activeClass);
  setTimeout(
    function () {
      this.find('li a').first().focus();
      const $toggle = this.find('.' + dropdownToggleClass).first();
      $toggle.attr('aria-expanded', true);
      $toggle.find('.toggle-label').text($toggle.data('label-close'));
      if (1 === Object.keys(openedSubnav).length) {
        $(document)
          .on('focusin.closing_subnav', tryClosingSubnav)
          .on('click.closing_subnav', tryClosingSubnav)
          .on('keyup.closing_subnav', tryClosingSubnavOnKeyUp);
      }
    }.bind($subnav),
    10
  );
}

function closeSubnav(subnavName) {
  const $subnav = getOpenedSubnavByName(subnavName);
  $subnav.removeClass(activeClass);
  const $toggle = $subnav.find('.' + dropdownToggleClass).first();
  $toggle.attr('aria-expanded', false);
  $toggle.find('.toggle-label').text($toggle.data('label-open'));
  delete openedSubnav[subnavName];
  if (!Object.keys(openedSubnav).length) {
    $(document)
      .off('click.closing_subnav')
      .off('focusin.closing_subnav')
      .off('keyup.closing_subnav');
  }
}

function calculateSubnavHeight() {
  const $subnav = $('.nav-primary .dropdown__subnav-wrapper');
  const scrollHeight = $subnav.prop('scrollHeight');
  document.documentElement.style.setProperty(
    '--subnav-height',
    `${scrollHeight}px`
  );
}

domReady(() => {
  calculateSubnavHeight();
  $navWithDropdown
    .find('.' + dropdownToggleClass)
    .on('click', function (event) {
      event.stopPropagation();
      const $dropdownContainer = $(this).closest(dropdownContainerSelector);
      if (!$dropdownContainer.hasClass(activeClass)) {
        setOpenedSubnav($dropdownContainer);
        openSubnav(getSubnavName($dropdownContainer));
      } else {
        closeSubnav(getSubnavName($dropdownContainer));
      }
    });
});
